<template lang="html">
  <div class="cw-invite-users">
    <div class="card-image">
      <div class="header hero is-small is-black">
        <div class="hero-body has-text-centered" :style="safeAreaInsetStyle">
          <div class="title is-3">Invite Users</div>
        </div>
      </div>
    </div>
    <div class="card-content">
      <div class="hero is-small">
        <div class="hero-body has-text-centered">
          <h3 class="title is-5">Add users to your Company Account</h3>
          <p class="is-5">
            Enter the email addresses of coworkers who you would like to invite
            to view and order service for company projects.
          </p>
        </div>
      </div>
      <cw-tag-input
        ref="tagInput"
        :tags="emails"
        validate="email"
        placeholder="Email addresses to invite"
      ></cw-tag-input>
      <div class="buttons is-padded-large has-text-centered">
        <a class="button is-black is-large is-rounded" @click="submit">
          <span>Send</span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import authRequired from '@/components/mixins/auth-required';
import safeArea from '@/components/mixins/safe-area';
import { mapState } from 'vuex';
import axios from 'axios';
let apiHost = process.env.VUE_APP_API_HOST;

export default {
  name: 'cw-invite-users',
  // share common functionality with component mixins
  mixins: [authRequired, safeArea],
  props: {},
  // variables
  data() {
    return {
      emails: [],
    };
  },
  computed: {
    ...mapState({
      token: state => state.user.token,
    }),
  },
  components: {},
  // methods
  watch: {},
  methods: {
    async submit() {
      if (!this.$refs.tagInput.addNew()) {
        return;
      }
      this.$modal.show('wifi-loader', { message: 'Processing...' });
      await this.$store.dispatch('user/refreshToken');
      try {
        await axios.post(
          `${apiHost}/auth/invite`,
          {
            invitedUsers: this.emails,
          },
          {
            headers: {
              Authorization: this.token,
            },
          }
        );

        this.emails = [];

        this.$modal.hide('wifi-loader');
        this.$modal.show('alert', {
          title: 'Invitations Sent',
          message: 'Your invitations have been sent and will arrive soon.',
        });

        this.$modal.hide('InviteUsers');
      } catch (err) {
        this.$modal.hide('wifi-loader');
        let res = err.response;
        if (res && res.data) {
          this.$modal.show('alert', {
            title: res.data.title,
            message: res.data.message,
            type: 'warning',
          });
        }
      }
    },
  },
};
</script>

<style lang="stylus">
.cw-invite-users .header.hero {
  background: #231F20

  .title {
    color: white;
  }
}
</style>
